import React from "react";
import { css, useTheme } from "@emotion/react";

import FormActions from "core/Components/Form/FormActions";

type Props = {
    children: React.ReactNode,
    isDisabled?: boolean,
};

const EventRegistrationFormActions: React.FC<Props> = ({
    children,
    isDisabled = false,
}) => {
    const theme = useTheme();

    const style = css`
        width: 166px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        flex-direction: column;

        &:hover {
            ${isDisabled && css`
                .need-detail {
                    color: ${theme.colours.red[999]};
                }
            `};
        }

        button {
            width: 160px;
            height: 41px;
            margin-top: 0;
            cursor: ${isDisabled ? 'default' : 'pointer'};

            .button-text {
                background-color: unset;
                color: ${isDisabled ? theme.colours.silverChalice4 : theme.colours.shipGray};
                font-size: 15px;
            }

            > div {
                background-color: ${isDisabled ? theme.colours.salomie : theme.colours.gold};
            }

            &:hover {
                ${!isDisabled && css`
                    > div {
                        background-color: ${theme.colours.mySin};
                    }
                `};
            }
            
            ${theme.breakpoints.down('md')} {
                width: 146px; 
                min-height: 37px;
                height: 37px;
                
                .button-text {
                    font-size: 13px;
                }
            }
        }
    `;

    return (
        <FormActions css={style} justifyContent={"flex-end"}>{children}</FormActions>
    );
}

export default EventRegistrationFormActions;
